<template>
    <div
        class="space-y-2"
        :class="variant === 'titleCentered' ? 'text-center' : ''"
        :style="rootStyle"
    >
        <div
            v-if="variant === 'titleImage'"
            class="flex flex-col gap-4"
            :class="isDesktop ? 'sm:flex-row sm:items-center' : ''"
        >
            <div class="flex-shrink-0 sm:w-1/2">
                <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    :alt="imageAlt"
                    class="w-full rounded-lg object-cover"
                />
                <PlaceholderImage
                    v-else
                    :label="title"
                    bg="var(--color-stack-tile-bg)"
                    class="h-40 w-full rounded-lg"
                />
            </div>
            <div class="min-w-0 flex-1 space-y-2">
                <h3 class="text-2xl font-bold text-stack-primary">
                    {{ title }}
                </h3>
                <p
                    v-if="text"
                    class="text-base leading-relaxed text-stack-text"
                >
                    {{ text }}
                </p>
            </div>
        </div>

        <template v-else>
            <h3 v-if="title" class="text-2xl font-bold text-stack-primary">
                {{ title }}
            </h3>
            <p v-if="text" class="text-base leading-relaxed text-stack-text">
                {{ text }}
            </p>
        </template>
    </div>
</template>

<script>
import PlaceholderImage from "@/components/editor/PlaceholderImage.vue";

export default {
    name: "TextSegment",
    components: { PlaceholderImage },
    props: {
        variant: { type: String, required: true },
        title: { type: String, required: true },
        text: { type: String, default: "" },
        imageUrl: { type: String, default: null },
        imageAlt: { type: String, default: "" },
        fontFamily: { type: String, default: null },
        isDesktop: { type: Boolean, default: true },
        previewOnly: { type: Boolean, default: false }
    },
    computed: {
        rootStyle() {
            return this.fontFamily ? { fontFamily: this.fontFamily } : {};
        }
    }
};
</script>
